<ng-container *ngIf="selection$ | async as selection">
  <ng-container>
    <button
      mat-icon-button
      data-automation-id="alden-action-button-download-all"
      (click)="download(selection)"
      [attr.aria-label]="'ALDEN.ACTIONS.DOWNLOAD_ALL_DOCUMENTS' | translate"
      [attr.title]="'ALDEN.ACTIONS.DOWNLOAD_ALL_DOCUMENTS' | translate"
    >
      <mat-icon>get_app</mat-icon>
    </button>
  </ng-container>
</ng-container>

<ng-template>
  <span>{{ 'ALDEN.ACTIONS.DOWNLOAD_ALL_DOCUMENTS' | translate }}</span>
</ng-template>
